import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import router from "./routes";

import "./globals.scss";

const rootElement: HTMLElement = document.getElementById("root") as any;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
   
    <RouterProvider router={router} />
      
  </React.StrictMode>
);
reportWebVitals();
